
import { Component, Vue, Watch } from 'vue-property-decorator'
import eventBus from '../../plugins/eventBus'
import api from '@/plugins/api'
import ItemSpecification from '../../components/ItemSpecification.vue'
import { ItemModel } from '@/store/models/ItemModel'
import { addToCartSuccess } from '@/plugins/popups'
import SimilarProducts from '@/components/SimilarProducts.vue'
import PeopleAlsoBought from '@/components/PeopleAlsoBought.vue'
import { FavoritesStore } from '@/store/stores/FavoritesStore'
import { envConfiguration } from '@/plugins/globalStaticDatas'
import { ItemCartModel } from '@/store/models/ItemCartModel'

import { UserModel } from '@/store/models/UserModel'

@Component({
  components: { PeopleAlsoBought, SimilarProducts, ItemSpecification },
})
export default class ItemDetails extends Vue {
  imagesKey: number = 0
  counter: any = 1
  disableBtn: boolean
  images: any = {
    thumbs: [],
    normal_size: [],
    large_size: [],
  }
  zoomerOptions: any = {
    zoomFactor: 1.5,
    pane: 'container',
    hoverDelay: 300,
    namespace: 'zoomer',
    move_by_click: false,
    scroll_items: 5,
    choosed_thumb_border_color: '#000000',
  }

  peopleAlsoBought: ItemModel[] = []
  envConfigurations: any = envConfiguration
  item: ItemModel = ItemModel.getInstance()
  favorites: FavoritesStore = FavoritesStore.getInstance()
  checkoutDetails: any[] | undefined
  itemCartModel: ItemCartModel = ItemCartModel.getInstance()
  user: UserModel = UserModel.getInstance()
  products = [
    {
      name: 'Product 1',
      description: 'Description for product 1.',
      image: 'path/to/default/image1.jpg',
      variants: [
        { name: 'Red', color: 'red', image: 'path/to/red/image1.jpg', description: 'Red variant description' },
      ],
    },
    {
      name: 'Product 2',
      description: 'Description for product 2.',
      image: 'path/to/default/image2.jpg',
      variants: [
        { name: 'Green', color: 'green', image: 'path/to/green/image2.jpg', description: 'Green variant description' },
      ],
    },
    {
      name: 'Product 3',
      description: 'Description for product 3.',
      image: 'path/to/default/image3.jpg',
      variants: [
        {
          name: 'Orange',
          color: 'orange',
          image: 'path/to/orange/image3.jpg',
          description: 'Orange variant description',
        },
      ],
    },
    {
      name: 'Product 4',
      description: 'Description for product 4.',
      image: 'path/to/default/image4.jpg',
      variants: [
        { name: 'Black', color: 'black', image: 'path/to/black/image4.jpg', description: 'Black variant description' },
      ],
    },
    {
      name: 'Product 5',
      description: 'Description for product 5.',
      image: 'path/to/default/image5.jpg',
      variants: [
        { name: 'Brown', color: 'brown', image: 'path/to/brown/image5.jpg', description: 'Brown variant description' },
      ],
    },
  ]

  selectedVariant: any = {}
  product = this.products[0] //

  get allVariants() {
    return this.products.flatMap((product) => product.variants)
  }

  selectVariant(variant) {
    this.selectedVariant = variant
    const selectedProduct = this.products.find((product) => product.variants.some((v) => v.name === variant.name))
    console.log(selectedProduct, 'sel')

    if (selectedProduct) {
      this.product = selectedProduct
    }
  }

  created() {
    // Set default selected variant
    this.selectedVariant = this.product.variants[0]
  }

  @Watch('favorites.items')
  onFavoritesStoreChange() {
    this.fetchProductsDetails()
  }

  @Watch('$route')
  onRouteParamChange() {
    this.fetchProductsDetails()
    document.body.getElementsByTagName('s-page')[0].scrollTop = 0
    eventBus.$emit('cart:item-selected')
  }

  fetchProductsDetails() {
    api()
      .get(`products/${this.$route.params.id}?resource=ProductDetailedResource`)
      .then((response: any) => {
        response.data.data.forEach((data: any) => {
          this.peopleAlsoBought = data.people_also_bought

          const itemPhotos = data.product.photos.map((item, index) => ({
            id: index + 1,
            url: `${this.envConfigurations.photoUrl}/${item}`,
          }))

          this.images = {
            thumbs: [...itemPhotos],
            normal_size: [...itemPhotos],
            large_size: [...itemPhotos],
          }

          const item = Object.assign(data.product, {
            isFavorite: this.isFavorite(data.product),
            image_default: data.product.image_default,
          })
          this.item.factory(item)
          this.imagesKey++
        })
      })
  }

  viewBuynowModal(product: any, total: any) {
    if (this.user.isLogged()) {
      api()
        .post(`/me/checkout-info`, {
          products: this.itemCartModel.assignItemData(this.item),
        })
        .then((response) => {
          this.checkoutDetails = response.data.data
          product.quantity = this.counter
          total = product.quantity * product.price

          eventBus.$emit('buynow-modal', product, total, this.checkoutDetails)
        })
        .catch((error) => {
          console.log(error)
        })
      return
    }

    api()
      .post(`/checkout-info`, {
        products: this.itemCartModel.assignItemData(this.item),
      })
      .then((response) => {
        this.checkoutDetails = response.data.data
        if (this.checkoutDetails) {
          product.quantity = this.counter
          total = product.quantity * product.price
          eventBus.$emit('buynow-modal', product, total, this.checkoutDetails)
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  addToFavorites(item: ItemModel) {
    item.addToFavorites()
  }

  isFavorite(item: ItemModel) {
    const isFavorite = (obj: any) => obj.id === item.id
    return this.favorites.getStore().some(isFavorite)
  }

  addToCart(item: ItemModel) {
    if (item.outOfStock) {
      return
    }
    console.log(this.counter, typeof this.counter)
    if (this.counter === 0) {
      this.counter = 1
    }
    eventBus.$emit('cart:item-added', item, this.counter)
    addToCartSuccess()
  }

  mounted() {
    this.fetchProductsDetails()
    eventBus.$on('cart:item-selected', this.fetchProductsDetails)
    this.disableBtn = this.counter <= 1
    console.log(this.selectedVariant, '456')
  }

  incrementValue() {
    this.counter++
  }
  decrementValue() {
    this.counter--
  }

  @Watch('counter')
  onCounterChange() {
    if (this.counter <= 1) {
      this.disableBtn = true
    } else if (this.counter > 1) {
      this.disableBtn = false
    }
  }
}
